import { render } from "./UserDetailsComponent.vue?vue&type=template&id=1c9d2b80&scoped=true"
import script from "./UserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./UserDetailsComponent.vue?vue&type=script&lang=js"

import "./UserDetailsComponent.vue?vue&type=style&index=0&id=1c9d2b80&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9d2b80"]])

export default __exports__